module.exports = __webpack_public_path__ + "img/Hsse_landscape.9bdb9bc0.jpg";